import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CasesContext from '../../context/CasesContext';
import ClassesContext from '../../context/ClassesContext';
import './AdminHome.css';
import Footer from '../Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ns-dashboard-api.kabilah.com';

function AdminHome() {
  const navigate = useNavigate();
  const { cases, loading } = useContext(CasesContext);
  const { classes, loading: classesLoading } = useContext(ClassesContext);
  const [realStudentCount, setRealStudentCount] = useState('—');
  const [demoStudentCount, setDemoStudentCount] = useState('—');

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/students`)
      .then((res) => {
        if (!Array.isArray(res.data)) return;
        setRealStudentCount(res.data.filter((s) => s.tag !== 'demo').length);
        setDemoStudentCount(res.data.filter((s) => s.tag === 'demo').length);
      })
      .catch(() => {
        setRealStudentCount('—');
        setDemoStudentCount('—');
      });
  }, []);

  const totalCases = loading ? '—' : cases.length;
  const totalClasses = classesLoading ? '—' : classes.length;

  const nurs310 = classes.find((c) => c.name === 'NURS 310');
  const nurs330 = classes.find((c) => c.name === 'NURS 330');
  const goToClass = (cls) => navigate(cls ? `/admin/classes/${cls.id}` : '/admin/classes');

  return (
      <div className="root-container">
        <div className="title-container">
          <div className="title-left">
            <div className="title-name-container">
              <header className="name-header">Admin Overview</header>
            </div>
          </div>
        </div>

        <div className="component-container">
          <div className="admin-home-content">
            <div className="stats-row">
              <div className="stat-card" onClick={() => navigate('/admin/cases')}>
                <span className="stat-value">{totalCases}</span>
                <span className="stat-label">Simulation Cases</span>
              </div>
              <div className="stat-card" onClick={() => navigate('/admin/classes')}>
                <span className="stat-value">{totalClasses}</span>
                <span className="stat-label">Classes</span>
              </div>
              <div className="stat-card" onClick={() => navigate('/admin/students')}>
                <span className="stat-value">{realStudentCount}</span>
                <span className="stat-label">Student Accounts</span>
                <span className="stat-sub">{demoStudentCount} demo account{demoStudentCount === 1 ? '' : 's'}</span>
              </div>
            </div>

            <div className="admin-home-section">
              <div className="section-header">
                <h2 className="section-title">Quick Actions</h2>
              </div>
              <div className="quick-actions-grid">
                <div className="quick-action-card" onClick={() => navigate('/admin/cases/chat')}>
                  <div className="quick-action-icon">💬</div>
                  <div className="quick-action-text">
                    <span className="quick-action-title">Create Simulation Case</span>
                    <span className="quick-action-desc">Build a new simulation case by chatting with Kabilah</span>
                  </div>
                </div>
                <div className="quick-action-card" onClick={() => goToClass(nurs310)}>
                  <div className="quick-action-icon">🎓</div>
                  <div className="quick-action-text">
                    <span className="quick-action-title">Manage NURS 310</span>
                    <span className="quick-action-desc">View the roster and assigned simulation cases for NURS 310</span>
                  </div>
                </div>
                <div className="quick-action-card" onClick={() => goToClass(nurs330)}>
                  <div className="quick-action-icon">🎓</div>
                  <div className="quick-action-text">
                    <span className="quick-action-title">Manage NURS 330</span>
                    <span className="quick-action-desc">View the roster and assigned simulation cases for NURS 330</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
  );
}

export default AdminHome;
